import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import Particles from '@tsparticles/react';
import noelImage from 'assets/themes/noel/image_39.png';
import horse1 from 'assets/themes/noel/horse1.png';
import { isDashboardRoute } from './isDashboardRoute';

const EFFECT_Z_INDEX = 11;

export default function NoelEffect() {
    const { pathname } = useLocation();
    const showSnow = isDashboardRoute(pathname);

    const options = useMemo(
        () => ({
            fullScreen: {
                enable: true,
                zIndex: 11,
            },
            particles: {
                number: {
                    value: 30,
                },
                color: {
                    value: '#ffffff',
                },
                move: {
                    direction: 'bottom',
                    enable: true,
                    speed: 1,
                },
                size: {
                    value: {
                        min: 2,
                        max: 6,
                    },
                },
                opacity: {
                    value: 0.8,
                },
            },
        }),
        [],
    );

    return (
        <div className="theme-effects-layer" aria-hidden>
            {showSnow ? <Particles id="snow" options={options} /> : null}
            <img
                src={horse1}
                alt=""
                style={{
                    position: 'fixed',
                    top: 0,
                    right: 360,
                    width: '20%',
                    height: '150px',
                    pointerEvents: 'none',
                    zIndex: EFFECT_Z_INDEX,
                }}
            />
            <img
                src={noelImage}
                alt=""
                style={{
                    position: 'fixed',
                    right: 0,
                    bottom: 15,
                    width: 200,
                    height: 'auto',
                    zIndex: EFFECT_Z_INDEX,
                    pointerEvents: 'none',
                }}
            />
        </div>
    );
}
